import { ReactElement, useEffect, useRef, useState } from 'react';
import { PopMenu, PopMenuButtonContainer, PopMenuExpandDirection, PopMenuTrigger } from './style';
// import { useOutsideClick } from "../../../utils/useOutsideClick";

export interface PopMenuButtonProps {
	opened: boolean;
	open?: () => void;
	close?: () => void;
	children: ReactElement;
	popChildren: ReactElement;
	$expandDirection: PopMenuExpandDirection;
	$horizontalDirection?: 'left' | 'right';
}

export function PopMenuButton({
	children,
	popChildren,
	$expandDirection,
	opened,
	open,
	close,
	$horizontalDirection = 'right',
}: Readonly<PopMenuButtonProps>) {
	const [popMenuTriggerHeight, setPopMenuTriggerHeight] = useState(0);
	const popMenuButtonRef = useRef<HTMLDivElement | null>(null);
	// const popMenuChildrenRef = useOutsideClick(() => {
	// 	close?.();
	// 	// e.stopPropagation();
	// });

	useEffect(() => {
		setPopMenuTriggerHeight(popMenuButtonRef.current?.clientHeight || 0);
	}, []);

	return (
		<PopMenuButtonContainer ref={popMenuButtonRef} className="triggercontainer">
			<PopMenuTrigger
				onClick={(e) => {
					if (opened) {
						close?.();
					} else {
						open?.();
					}
					e.stopPropagation();
				}}
			>
				{children}
			</PopMenuTrigger>
			{opened && (
				<PopMenu
					height={popMenuTriggerHeight}
					$expandDirection={$expandDirection}
					$horizontalDirection={$horizontalDirection}
				>
					{popChildren}
				</PopMenu>
			)}
		</PopMenuButtonContainer>
	);
}
